/**
 * Sidebar Validated filter: binds RmaListFiltersStore restock-validated draft to
 * RmaListFilterControl via filterControlDataProps (single-select radio list).
 */
import { observer } from "mobx-react";
import useDashboardTranslation from "../../../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import { RESTOCK_VALIDATED_TYPE } from "../../../../../../../services/api/rma-list-service";
import RmaListFiltersStore from "../../../../../rma-list-page/stores/rma-list-filters-store";
import {
    MANAGE_RETURNS_DESIGN_VERSION,
    trackManageReturnsListEvent,
} from "../../../../../utils/manage-returns-list-mixpanel";
import { RMA_LIST_FILTER_CONTROL_DATA_TYPE } from "../rma-list-filter-control/components/rma-list-filter-control-portal/rma-list-filter-control-content/rma-list-filter-control-content";
import RmaListFilterControl from "../rma-list-filter-control/rma-list-filter-control";

interface IProps {
    rmaListFiltersStore: RmaListFiltersStore;
    disabled?: boolean;
}

const RmaListFilterValidated: React.FC<IProps> = observer(({ rmaListFiltersStore, disabled }) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = "dashboard-returns-page";
    const selectedId = rmaListFiltersStore.selectedRestockValidatedId;

    return (
        <RmaListFilterControl
            label={getTranslation("VALIDATED", scope)}
            selectedLabel={rmaListFiltersStore.selectedRestockValidatedLabel}
            disabled={disabled}
            onOpen={() => trackManageReturnsListEvent("d&_filter_validated", MANAGE_RETURNS_DESIGN_VERSION.V2)}
            onClear={() => rmaListFiltersStore.setRestockValidatedType(RESTOCK_VALIDATED_TYPE.ALL)}
            filterControlDataProps={{
                type: RMA_LIST_FILTER_CONTROL_DATA_TYPE.OPTIONS,
                value: selectedId,
                options: rmaListFiltersStore.restockValidatedFilterOptions,
                onChange: (id) => {
                    rmaListFiltersStore.setRestockValidatedType(id as RESTOCK_VALIDATED_TYPE);
                },
            }}
        />
    );
});

export default RmaListFilterValidated;
